<template>
  <section class="content">
    <h2 class="subtitle">
      Digital Signature and Confirmation
    </h2>
    <p>By selecting "yes" below, I affirm that:</p>
    <ul>
      <li>This is my first and only ballot.</li>
      <li>I have followed the rules for submission.</li>
    </ul>
    <label class="checkbox">
        <input type="checkbox" name="affirmation" required="required">
        I Affirm
    </label>
  </section>
</template>

<script>
export default {
  //
};
</script>
